<template>
  <b-container class="bv-example-row" id="orders" fluid>
    <b-row>
      <b-col>
        <h2>Orders</h2>
      </b-col>
      <b-col>
        <h3>テーブル：{{ tableNo }}</h3>
      </b-col>
    </b-row>
    <transition name="fade">
      <b-row v-if="ordersDelivered.length > 0">
        <b-button variant="info">会計</b-button>
        <b-card
          class="text-center"
          v-for="(item, index) in ordersDelivered"
          :key="index">
          {{ item.menuName }} ( ￥{{ item.price }} ) X {{ item.count }}
        </b-card>
      </b-row>
    </transition>
    <hr />
    <transition name="fade">
      <b-row v-if="ordersEntry.length > 0">
        <b-button v-on:click="createOrder()" variant="info">注文確定</b-button>
        <b-card
          class="text-center"
          v-for="(item, index) in ordersEntry"
          :key="index"
        >
          {{ item.menuName }}
          <b-badge variant="danger">￥{{ item.price }} </b-badge> X
          {{ item.count }}
          <b-button variant="light" v-on:click="deleteOrderEntry(index)">
            <b-icon icon="trash-fill" scale="1" variant="danger"></b-icon>
          </b-button>
        </b-card>
      </b-row>
    </transition>
    <b-row>
      <div>
        <b-card-group deck>
          <b-card v-for="item in menus" :key="item.id"
            border-variant="primary"
            :title="item.name"
            :img-src="item.photo"
            img-height="300px"
            img-top
            class="mb-2">
            <b-card-text>{{ item.description }}</b-card-text>
            <b-card-text><h3><b-badge variant="danger">￥{{ item.price }}</b-badge></h3></b-card-text>
            <b-input-group>
              <b-form-spinbutton v-model="item.count" inline min="1" max="10" size="sm" style="width: 10rem;"></b-form-spinbutton>
              <b-button
                v-on:click="addOrderEntry(item.id, item.name, item.price, item.count)"  variant="success"
                size="sm">追加</b-button
              >
            </b-input-group>
          </b-card>
        </b-card-group>
      </div>
    </b-row>
  </b-container>
</template>

<script>
import { API } from "aws-amplify";
import { listMenus } from "../graphql/queries";
import { createOrder, createOrderDetail } from "../graphql/mutations";
// import { createOrder } from "../graphql/mutations";
import { onCreateOrder } from "../graphql/subscriptions";
// import { OrderStatus } from "./models";

// // to disable Analytics
// Analytics.disable();

// // to enable Analytics
// Analytics.enable();

export default {
  name: "Orders",
  async created() {
    this.getMenus();
    this.subscribe();
  },
  data() {
    return {
      tableNo: 21,
      order: {},
      ordersEntry: [],
      ordersDelivered: [],
      menus: [],
    };
  },
  methods: {
    async getMenus() {
      const menus = await API.graphql({
        query: listMenus,
      });
      console.log(menus.data);
      this.menus = menus.data.listMenus.items;
      this.menus.forEach((element) => (element["count"] = 1));
    },

    async addOrderEntry(id, name, price, count) {
      console.log(id + ":" + name);
      const orderEntry = {
        menuName: name,
        menuId: id,
        price: price,
        count: count,
        status: "IN_TRANSIT",
      };
      this.ordersEntry = [...this.ordersEntry, orderEntry];
    },

    async deleteOrderEntry(index) {
      this.ordersEntry.splice(index, 1);
    },
    async createOrder() {
      //this.ordersEntry.forEach((element) => console.log(element));
      try {
        const order = {
          tableNo: this.tableNo,
          status: "ALIVE",
        };
        const newOrder = await API.graphql({
          query: createOrder,
          variables: { input: order },
        });
        console.log("createOrder:", newOrder);
        this.order = newOrder;
      } catch (error) {
        console.log("error: ", error);
      }
    },
    async submitOrderDetails(orderId) {
      this.ordersEntry.forEach(async (element, index) => {
        element["orderId"] = orderId;
        console.log("orderDetail to create:", element);
        await API.graphql({
          query: createOrderDetail,
          variables: { input: element },
        }).catch((error) => console.log(error));
        this.ordersDelivered.push(element);
        this.ordersEntry.splice(index, 1);
      });
    },

    subscribe() {
      API.graphql({ query: onCreateOrder }).subscribe({
        next: (eventData) => {
          console.log("onCreateOrder:", eventData);
          let order = eventData.value.data.onCreateOrder;
          this.order = order;

          this.submitOrderDetails(order.id);
        },
      });
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>